import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ThemingService } from 'src/app/theming.service';
import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef } from '@angular/core';
declare var $: any;

import { AuthService } from 'src/app/auth.service';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit {
  childShops: { shopId: number, shopName: string, shopLogo?: string, shopGuid: string }[] = [];
  selectedShopId: number = this.themingService.shopId;

  permissions: any = {};
  hasAccess!: boolean;

  shopLogos: { white: string; large: string; small: string } = {
    white: '',
    large: '',
    small: ''
  };
  isLoading: boolean = true;
  shopName: string = '';

  constructor(
    private router: Router,
    public themingService: ThemingService,
    private authService: AuthService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef
  ) {
    translate.setDefaultLang('es');
    translate.use('es');
  }

  ngOnInit(): void {
    this.authService.getUserPermissions().then((permissions) => {
      this.permissions = permissions;
      if ((this.themingService.shopId === 4 || this.themingService.shopId === 9 || this.themingService.shopId === 15 || this.themingService.shopId === 22) && this.permissions.calendar === true) {
        this.hasAccess = true;
      } else {
        this.hasAccess = false;
      }
    }).catch((error) => {
      console.error('Error getting user permissions:', error);
    });
    this.getShopTheming();
  }

  getShopTheming() {
    this.themingService.getThemingService().then(() => {
      const theming = this.themingService.shopTheming[0];
      this.childShops = []
      if (theming) {
        this.shopLogos.white = theming.shopLogoWhite;
        this.shopLogos.large = theming.shopLogoLarge;
        this.shopLogos.small = theming.shopLogoSmall;
        this.shopName = theming.shopName;
        this.childShops = [
          {
            shopId: this.themingService.shopId,
            shopName: theming.shopName?.trim(),
            shopLogo: theming.shopLogoSmall || '../../../assets/icons/user.svg',
            shopGuid: this.themingService.shopGuid
          },
          ...this.themingService.childShops
        ];
      }
    }).catch((error) => {
      console.error('Error getting theming service:', error);
    }).finally(() => {
      this.isLoading = false;
    });
  }

  getShopLogo(shopId: number): string {
    if (shopId === this.themingService.shopId) {
      return this.shopLogos.small;
    }

    const theme = this.themingService.shopTheming.find(t => t.shopId === shopId);
    if (theme?.shopLogoSmall) return theme.shopLogoSmall;

    const child = this.childShops.find(c => c.shopId === shopId);
    return child?.shopLogo ?? '../../../assets/icons/user.svg';
  }

  hasChildShops(): boolean {
    return this.themingService.childParentIds.length > 0;
  }

  onSignOut() {
    document.cookie = "fromParent=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.removeItem('parentShopInfo');
    this.authService.onSignOut().then(() => {
      this.router.navigate(['/login']);
    });
  }

  getShopName(shopId: number): string {
    const allShops = [
      { shopId: this.themingService.shopId, shopName: this.shopName },
      ...this.themingService.childShops
    ];
    const found = allShops.find(shop => shop.shopId === shopId);
    return found?.shopName ?? 'Tienda';
  }

  onChildShopChange(selectedId: number) {
    const selectedShop = this.childShops.find(shop => shop.shopId === selectedId);
    if (!selectedShop || selectedShop.shopGuid === this.themingService.shopGuid) return;

    this.selectedShopId = selectedId;

    const isInParentShop = this.themingService.childParentIds.length > 0;

    if (isInParentShop) {
      document.cookie = "fromParent=true; path=/; max-age=600";

      const parentShopInfo = {
        shopId: this.themingService.shopId,
        shopGuid: this.themingService.shopGuid,
        shopName: this.shopName,
        shopLogo: this.shopLogos.small
      };
      localStorage.setItem('parentShopInfo', JSON.stringify(parentShopInfo));
    }

    this.themingService.setShopId(selectedShop.shopId, selectedShop.shopGuid);

    this.router.navigate(['/']).then(() => {
      location.reload();
    });
  }


  openModal() {
    $('#settingsModal').modal('show');
  }
}
